import app from '../../App';

export default class PlansService {
    generatePlanServiceValueObject(obj) {
        return {
            basePrice:obj.BasePrice,
            maxDevices:obj.MaxDevices,
            minDevices:obj.MinDevices,
            name:obj.Name?obj.Name:'',
            percentageOffDevicesForAnnual:obj.PercentageOffDevicesForAnnual,
            pricePerLicense:obj.PricePerLicense,
            devicePrice:obj.DevicePrice?obj.DevicePrice:199,
            percentageOffLicensesForAnnual:obj.PercentageOffLicensesForAnnual
        };
    };
    constructor($log, $http, Info) {
        'ngInject';
        this._$http = $http;
        this.Info=Info;
    }
    //depracated
    // getAutoBillingPlans() {
    //     return this._$http({
    //         method: 'GET',
    //         url: 'https://adservernet.enplug.com/v1/autobilling/plans'
    //     });
    // }
    //
    // getAutoBillingGroupedPlans() {
    //     return this._$http({
    //         method: 'GET',
    //         url: 'https://adservernet.enplug.com/v1/autobilling/plans/groups'
    //     });
    // }

    getNewBillingPlans() {
        return this._$http({
            method: 'GET',
            url: `${this.Info.host}v1/autobilling/plans`
        });
    }
};

app.service('PlansService', PlansService);


// WEBPACK FOOTER //
// ./src/js/services/checkout-flow/PlansService.js